import React from "react";
import { useTranslation } from "react-i18next";
import { THEME } from "@/enums/profile";
import { MessageContentPieChart } from "@/services/wingman";
import { GailPieChart } from "@repo/ui/gailgpt/charts";

const AskPieChart: React.FC<{
  chartData: MessageContentPieChart["chart"];
  themeOverride?: THEME;
  brandOverride?: string;
}> = ({ chartData }) => {
  const { t } = useTranslation("ask");
  const points = (chartData.data ?? []).flatMap((item) =>
    typeof item.label === "string" && typeof item.value === "number" ? [{ label: item.label, value: item.value }] : [],
  );
  if (points.length === 0) {
    return <div>{t("chartFailed")}</div>;
  }
  return <GailPieChart title={chartData.title} points={points} />;
};

export default AskPieChart;
